import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Checkbox } from 'pretty-checkbox-react';
import Select from 'react-select';

import AlertMsg from '../../components/AlertMsg';
import config from '../../api/config.json';
import api from '../../api';

const ModalChangeStatusBySupervisor = props => {
  const {
    modalShowChangeStatus,
    setModalShowChangeStatus,
    dataModalChangeStatus,
    setDataModalChangeStatus
  } = props;

  const agentLoginId = '5972571dbe9d01feb20f45b7';
  const agentReadyId = '5972571dbe9d01feb20f45b6';
  const customStyle = {
    control: provided => ({
      ...provided,
      borderRadius: '0px',
      '&:hover': {
        color: '#495057',
        backgroundColor: '#fff',
        borderColor: '#80bdff',
        outline: 0,
        boxShadow: '0 0 0 .2rem rgba(0,123,255,.25)'
      }
    }),
    menu: provided => ({ ...provided, marginTop: '1px' }),
    downchevron: provided => ({ ...provided, borderRadius: '100px' })
  };

  const customThemes = theme => ({
    ...theme,
    colors: { ...theme.colors, primary: '#80bdff' }
  });

  const [optionsStatus, setOptionsStatus] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [failRequest, setFailRequest] = useState(false);
  const groupsAvailable = dataModalChangeStatus.groups
    ? dataModalChangeStatus.groups.map(grp => ({
      id: grp.groupId,
      name: grp.name,
      number: grp.group,
      logged: grp.logged
    }))
    : [];

  const extensionLogoutSupervisor = async (id, number) => {
    try {
      setIsFetching(true);
      setFailRequest(false);
      const obj = {
        extension: number,
        idExtension: id
      };
      await api().post('/api/devices/logout_extension', obj);
    } catch (err) {
      console.error(err);
      setFailRequest(true);
    } finally {
      setTimeout(() => setIsFetching(false), 2000);
    }
  };

  const LoginGroupSupervisor = async ({ group, idGroup }) => {
    try {
      const idExtension = dataModalChangeStatus._id;
      const extension = dataModalChangeStatus.extension;
      const idUser = dataModalChangeStatus.user;
      if (idExtension && idUser && group && idGroup) {
        const obj = {
          group,
          extension,
          idUser,
          idExtension,
          idGroup,
          status: 'disponível'
        };
        await api().post('/api/group/login_group', obj);
      }
    } catch (err) {
      console.error(err);
      setFailRequest(true);
    } finally {
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  const LogoutGroupSupervisor = async ({ group, idGroup }) => {
    try {
      const idExtension = dataModalChangeStatus._id;
      const extension = dataModalChangeStatus.extension;
      if (idExtension && group && idGroup) {
        const obj = {
          group,
          extension,
          idExtension,
          idGroup
        };
        await api().post('/api/group/logout_group', obj);
      }
    } catch (err) {
      console.error(err);
      setFailRequest(true);
    } finally {
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  const handleChangeLoginLogoutGroupSupervisor = (id, number, logged) => {
    if (!logged) {
      if (
        !dataModalChangeStatus.idStatus ||
        dataModalChangeStatus.idStatus === agentReadyId
      ) {
        setIsFetching(true);
        setFailRequest(false);
        LoginGroupSupervisor({ group: number, idGroup: id });
      }
    } else {
      setIsFetching(true);
      setFailRequest(false);
      LogoutGroupSupervisor({ group: number, idGroup: id });
    }
  };

  const getPauseStatus = async () => {
    try {
      setIsFetching(true);
      setFailRequest(false);
      const status = await api().get('/api/status');
      const removeItems = [agentLoginId, agentReadyId];
      const options = status.data
        .filter(status => !removeItems.includes(status._id))
        .map(status => {
          return {
            value: status._id,
            name: status.name,
            label: (
              <span className="text-capitalize">
                &nbsp;
                <i className={status.icon} />
                &nbsp;&nbsp;{status.name}
              </span>
            )
          };
        });
      options.sort((a, b) => a.name.localeCompare(b.name));
      options.unshift({
        value: agentReadyId,
        name: 'disponível',
        label: (
          <span className="text-capitalize">
            &nbsp;
            <i className="fa fa-check" />
            &nbsp;&nbsp;disponível
          </span>
        )
      });
      setOptionsStatus([...options]);
    } catch (err) {
      console.error(err);
      setFailRequest(true);
    } finally {
      setTimeout(() => setIsFetching(false), 1000);
    }
  };

  const handleChangeStatusPause = async evt => {
    try {
      setIsFetching(true);
      setFailRequest(false);
      const { value } = evt;
      const { extension } = dataModalChangeStatus;
      const newStatus = optionsStatus.find(status => status.value === value);
      if (value !== dataModalChangeStatus.idStatus && extension && newStatus) {
        const obj = {
          extension,
          status: newStatus.name.toLowerCase(),
          idUser: dataModalChangeStatus.user,
          type: newStatus.value === agentReadyId ? 'ready' : 'notReady',
          idStatus: newStatus.value
        };
        await api().post('/api/group/ready_notready_group', obj);
      }
    } catch (err) {
      console.error(err);
      setFailRequest(true);
    } finally {
      setTimeout(() => setIsFetching(false), 2550);
    }
  };

  return (
    <React.Fragment>
      <Modal
        show={modalShowChangeStatus}
        onExited={() => {
          setDataModalChangeStatus({});
        }}
        onHide={() => {
          setModalShowChangeStatus(false);
        }}
        onEntering={() => getPauseStatus()}
      >
        <Modal.Body>
          {!failRequest && (
            <AlertMsg
              type="info"
              msg="Área de troca de status pelo supervisor"
            />
          )}
          {failRequest && (
            <AlertMsg type="danger" msg="Falha na requisição da operação" />
          )}
          <div className="user-pic text-center mb-n4 mt-3">
            <img
              className="img-responsive p-2 mb-4 rounded-circle"
              style={{
                backgroundColor: `${
                  String(dataModalChangeStatus.status).toLocaleLowerCase() ===
                  'indisponível'
                    ? '#757575'
                    : String(
                        dataModalChangeStatus.status
                      ).toLocaleLowerCase() === 'disponível'
                    ? '#2DA58A'
                    : '#D4565F'
                }`
              }}
              src={`${config.protocol}://${config.ipServerGW}:${config.portServerGW}/api/users/image/${dataModalChangeStatus.user}`}
              alt="Avatar"
            />
          </div>
          <div className="text-center mt-1">
            <p className="font-weight-bold mb-1">
              <i className="fa fa-user" />
              &nbsp;
              {dataModalChangeStatus.userName}&nbsp;:&nbsp;
              <i className="fa fa-building" />
              &nbsp;{dataModalChangeStatus.department}
            </p>
          </div>
          <div className="text-center">
            <button
              type="button"
              className="btn btn-danger font-weight-bold w-75"
              onClick={() =>
                extensionLogoutSupervisor(
                  dataModalChangeStatus._id,
                  dataModalChangeStatus.extension
                )
              }
              disabled={isFetching}
            >
              <i className="fa fa-unlink" />
              &nbsp;DESLOGAR RAMAL&nbsp;
              <span
                className="badge badge-secondary"
                style={{ fontSize: '100%' }}
              >
                {dataModalChangeStatus.extension}
              </span>
            </button>
          </div>
          <div>
            <p className="font-weight-bold mt-3 mb-0">
              <i className="fa fa-users" />
              &nbsp;Grupos Disponíveis
            </p>
            {groupsAvailable.length ? (
              groupsAvailable.map(grp => {
                return (
                  <Checkbox
                    className="mb-2 d-block"
                    key={grp.id}
                    inputProps={{ name: grp.number }}
                    type="checkbox"
                    color="primary-o"
                    animation="smooth"
                    onChange={() =>
                      handleChangeLoginLogoutGroupSupervisor(
                        grp.id,
                        grp.number,
                        grp.logged
                      )
                    }
                    disabled={isFetching}
                    checked={grp.logged}
                  >
                    <span className="sidebar-subtitle">{`${grp.number} - ${grp.name}`}</span>
                  </Checkbox>
                );
              })
            ) : (
              <span>Nenhum Grupo Configurado</span>
            )}
          </div>
          <div className="form-row m-0">
            <p className="font-weight-bold mt-2 mb-0">
              <i className="fa fa-pause" />
              &nbsp;Pausa Usuário
            </p>
            <div className="w-75 pl-0">
              <Select
                value={
                  optionsStatus.find(
                    opt => opt.value === dataModalChangeStatus.idStatus
                  ) || optionsStatus.find(opt => opt.value === agentReadyId)
                }
                onChange={handleChangeStatusPause}
                isDisabled={
                  isFetching ||
                  !groupsAvailable.filter(grp => grp.logged).length ||
                  !optionsStatus.length
                }
                options={optionsStatus.filter(
                  opt => opt.value !== dataModalChangeStatus.idStatus
                )}
                isSearchable={false}
                theme={customThemes}
                styles={customStyle}
                // ref={pauseSelected}
              />
            </div>
            <div className="col pr-0">
              <button
                type="button"
                className="btn btn-info w-100"
                title="Atualizar Listagem"
                disabled={isFetching}
                onClick={getPauseStatus}
              >
                <i className="fa fa-sync-alt" />
              </button>
            </div>
          </div>
          <button
            type="button"
            className="mt-3 btn btn-secondary float-right"
            onClick={() => setModalShowChangeStatus(false)}
          >
            <i className="fas fa-times" />
            &nbsp;Fechar
          </button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalChangeStatusBySupervisor.propTypes = {
  modalShowChangeStatus: PropTypes.bool,
  setModalShowChangeStatus: PropTypes.func,
  dataModalChangeStatus: PropTypes.object,
  setDataModalChangeStatus: PropTypes.func
};

export default ModalChangeStatusBySupervisor;
